import React from 'react'
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";

const About_TNPSC = () => {

      const tnpsclist =[
        {contlist:"All the tests will be conducted for 250 marks."},
        {contlist:"Question Paper cum Answer booklet will be provided only in Printed format."},
        {contlist:"Question papers based on the dynamics of TNPSC."},
        {contlist:"Our test series is a real simulation of the TNPSC Group I Main exam."},
        {contlist:"Explanatory Materials for Unit Tests in Bilingual (Soft Copy)."},
        {contlist:"Printed answer-booklets of SIA’s 2022 cleared candidates (Issued for both offline & online students in book format)"},
        {contlist:"Recorded Orientation/Discussion Videos.(For further reference)"},
        {contlist:"8*7 Individual Mentoring by Expert Team (Only at SIA Branches)"},
        {contlist:"Z+ Series – Group I Mains Current Affairs Material (Zero Current Affairs for Mains)"},
        {contlist:"Z+ Series – Crash Course for Main Current Affairs (For both offline and online students)"},
        {contlist:"“Skill Up Junction” - Motivational Session (By SIA’s Cleared Candidates periodically)"},
        {contlist:"Mentoring Carnival for Online and SIA Branch Students"},
        {contlist:"We will conduct a Doubt Clearing Session."},
        {contlist:"Value Addition Lecture Series (Only for Test Batch Students – on most important topics)"}
    ]

      const tnpsclist1 =[
        {contlist:"All the tests will be conducted for 300 marks"},
        {contlist:"Question Paper cum Answer booklet will be provided only in Printed format"},
        {contlist:"Question papers based on the dynamics of TNPSC."},
        {contlist:"Our test series is a real simulation of the TNPSC Group II/IIA Main exam."},
        {contlist:"Our test series covers the syllabus holistically."},
        {contlist:"Provides platform for State Level Analysis of performance and improve your competency."},
        {contlist:"Flexible for working candidates to take the test as per their availability."},
        {contlist:"Special Focus will be given for Unit II, III, IV and V."},
        {contlist:"Explanatory notes for all Tests (Except Mock Tests) will be provided in bilingual mode. Shankar IAS Academy is the only institute that provides such facility."}
      ]

      const tnpsclist2 =[
        {contlist:"Our test series is a real simulation of the TNPSC Group I Prelims exam."},
        {contlist:"Our test series covers the syllabus holistically."},
        {contlist:"Our test series is based on the dynamism of TNPSC"},
        {contlist:"All the tests will be conducted for 200 questions only"},
        {contlist:"We do post test discussion analysis on the perspective of difficulty level, conceptual level, Current Event level, etc.,"},
        {contlist:"Recorded post test discussion analysis will be provided for further reference."},
        {contlist:"Provides a platform for State Level Analysis of performance and improves your competency."},
        {contlist:"Flexible for working candidates to take the test as per their availability."}
      ]

      const tnpsclist3 =[
        {contlist:"Free Interview classes."},
        {contlist:"Individual attention."},
        {contlist:"Mock Interview by serving bureaucrats and others."},
        {contlist:"Mock Interview will be recorded and analysis will be shared for further enhancement."}
      ]
  return (
    <>
                <div className="container">
                    <div className="row pt-3">
                        <div className="col">
                        <h2 className={`${styles.sectiontitle}`}>TNPSC Group I Main Test Series</h2>
                        {tnpsclist.map((item,index)=>(
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                       {item.contlist}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        ))}

                       
                       </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row pt-4">
                        <div className="col">
                          <h2 className={`${styles.sectiontitle}`}>TNPSC Group II/IIA Main Test Series</h2>
                            {tnpsclist1.map((item,index)=>(
                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                              {item.contlist}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            ))}

                       </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row pt-4">
                        <div className="col">
                          <h2 className={`${styles.sectiontitle}`}>Prelims Test Series</h2>
                          {tnpsclist2.map((item,index)=>(
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            {item.contlist}
                                            </p>
                                        </div>
                                    </li>
                            </ul>
                          ))}

                       </div>
                    </div>
                </div>
                       
                <div className="container">
                    <div className="row pt-4">
                        <div className="col">
                          <h2 className={`${styles.sectiontitle}`}>Interview Guidance</h2>
                          {tnpsclist3.map((item,index)=>(
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                        {item.contlist}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                          ))}
                       
                       </div>
                    </div>
                </div>
</>
  )
}

export default About_TNPSC;